import { BATTLE_PASS_TIERS, DEFAULT_BATTLE_PASS, CURRENT_SEASON_ID, type BattlePassState, type BattlePassTier } from '@/models/battle-pass';

export class BattlePassManager {
  private state: BattlePassState = { ...DEFAULT_BATTLE_PASS };

  addXP(amount: number): { newTier: boolean; oldTier: number; newTierNum: number } {
    const oldTier = this.state.tier;
    this.state.xp += amount;

    // Check tier advancement
    while (this.state.tier < BATTLE_PASS_TIERS.length) {
      const nextTier = BATTLE_PASS_TIERS[this.state.tier]!;
      if (this.state.xp >= nextTier.xpRequired) {
        this.state.tier++;
      } else {
        break;
      }
    }

    return {
      newTier: this.state.tier > oldTier,
      oldTier,
      newTierNum: this.state.tier,
    };
  }

  claimFreeReward(tier: number): { type: string; value: number | string } | null {
    if (tier < 1 || tier > this.state.tier) return null;
    if (this.state.claimed.includes(tier)) return null;
    const tierDef = BATTLE_PASS_TIERS[tier - 1];
    if (!tierDef) return null;
    this.state.claimed.push(tier);
    return tierDef.freeReward;
  }

  claimPremiumReward(tier: number): string | null {
    if (!this.state.premium) return null;
    if (tier < 1 || tier > this.state.tier) return null;
    if (this.state.claimedPremium.includes(tier)) return null;
    const tierDef = BATTLE_PASS_TIERS[tier - 1];
    if (!tierDef?.premiumReward) return null;
    this.state.claimedPremium.push(tier);
    return tierDef.premiumReward.value;
  }

  activatePremium(): void {
    this.state.premium = true;
  }

  isPremium(): boolean { return this.state.premium; }
  getCurrentTier(): number { return this.state.tier; }
  getCurrentXP(): number { return this.state.xp; }
  getXPForNextTier(): number {
    if (this.state.tier >= BATTLE_PASS_TIERS.length) return 0;
    return BATTLE_PASS_TIERS[this.state.tier]!.xpRequired;
  }
  getState(): BattlePassState { return { ...this.state, claimed: [...this.state.claimed], claimedPremium: [...this.state.claimedPremium] }; }
  isFreeClaimed(tier: number): boolean { return this.state.claimed.includes(tier); }
  isPremiumClaimed(tier: number): boolean { return this.state.claimedPremium.includes(tier); }

  restoreState(state: BattlePassState | null): void {
    if (!state || state.seasonId !== CURRENT_SEASON_ID) {
      this.state = { ...DEFAULT_BATTLE_PASS };
      return;
    }
    this.state = { ...state, claimed: [...state.claimed], claimedPremium: [...(state.claimedPremium ?? [])] };
  }
}
